import React from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { Breadcrumb, Breadcrumbs, Typography } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import Jumbotron from '../../components/Basics/Jumbotron'
import {
  Card,
  GridContainer,
  GridItem,
  JumboDescription,
  JumboTitle,
  Root,
  StarIcon
} from './SmallerCompaniesSection.styles'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'

/**
 * The SmallerCompaniesSection's container.
 *
 */
const SmallerCompaniesSection = () => {
  const {
    size: { isUpToMedium }
  } = useViewport()

  return (
    <Root>
      <GridContainer>
        <GridItem xs={12}>
          <Jumbotron color="blue" height={isUpToMedium ? '295px' : 'auto'}>
            <GridItem xs={12}>
              <Breadcrumbs>
                <Breadcrumb to={routes.root} variant="link">
                  Datos Abiertos
                </Breadcrumb>
                <Breadcrumb to={routes.providers} variant="link">
                  Proveedores
                </Breadcrumb>
                <Breadcrumb>Empresas de Menor Tamaño</Breadcrumb>
              </Breadcrumbs>
            </GridItem>
            <GridContainer>
              <GridItem xs={6}>
                <JumboTitle>Empresas de Menor Tamaño</JumboTitle>
              </GridItem>
              <ProtectByFeatures rule={features => features['cl.chilecompra.datos-abiertos/new-section']}>
                <GridItem xs={4}>
                  <Card color="primary" width="88px">
                    <Typography
                      variant="body1"
                      color="primary"
                      fontWeight="normal"
                      fontSize="12px"
                      lineHeight="14px"
                      padding="4px 0 0 0"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      NUEVO <StarIcon style={{ verticalAlign: 'middle' }} />
                    </Typography>
                  </Card>
                </GridItem>
              </ProtectByFeatures>
            </GridContainer>
            <GridItem xs={12}>
              <JumboDescription>
                Las empresas de menor tamaño en Chile son micro, pequeñas y medianas empresas, clasificadas según sus
                ingresos anuales por ventas y servicios.
              </JumboDescription>
            </GridItem>
          </Jumbotron>
        </GridItem>
      </GridContainer>
    </Root>
  )
}
export default SmallerCompaniesSection
